import { isEmpty, map } from 'lodash';

function getUsersExcelStatistics(users) {
  const statistics = [];

  if (isEmpty(users)) {
    return statistics;
  }

  map(users, (value, key) => {
    statistics.push({
      username: key,
      numOfImports: value.count,
    });
  });

  return statistics;
}

function getClientsExcelStatistics(clients) {
  const statistics = [];

  if (isEmpty(clients)) {
    return statistics;
  }

  map(clients, (value, key) => {
    const count = value.map(user => user.count).reduce((a, b) => a + b, 0);
    statistics.push({
      name: key,
      numOfImports: count,
    });
  });

  return statistics;
}

function getClientsWithUsersExcelStatistics(clients, selectedClients) {
  const clientNames = [];
  const usersData = [];

  if (isEmpty(clients) || isEmpty(selectedClients)) {
    return {
      clientNames: [],
      usersData: [],
    };
  }

  const selectedClientsNames = selectedClients.map(selectedClient => selectedClient.name);

  map(clients, (value, key) => {
    if (!selectedClientsNames.includes(key)) {
      return;
    }
    clientNames.push(key); // name of repo
    usersData.push(value); // array of users
  });

  return {
    clientNames,
    usersData,
  };
}

export default {
  getUsersExcelStatistics,
  getClientsExcelStatistics,
  getClientsWithUsersExcelStatistics,
};
